import React, { useContext, useEffect } from 'react';
import http from '../../utils/http';
import { ConfigContext } from '../../Config/ConfigContext';
import auth from '../../utils/auth';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const UserInit = ({ redirectRoute = '/', unAuthedRoute = '/unauthorized' }) => {
	const { config } = useContext(ConfigContext);

	useEffect(() => {
		(async () => {

			await sleep(1000);
			const queryParams = window.location.search
				.replace('?', '')
				.split('&')
				.reduce((previous, current) => {
					const [key, value] = current.split('=');
					return {
						...previous,
						[key]: value,
					};
				}, {});

			if (queryParams.verificationToken) {
				auth.setBearerToken(queryParams.verificationToken);
			}

			const verifyResult = await http.get(
				{},
				`${config.uri.base}/user/validate`
			);

			if (verifyResult?.valid == true) {
				window.location.href = redirectRoute;
			} else {
				window.location.href = unAuthedRoute;
			}
		})();
	}, []);

	return (
		<div className="verifyUserParetnContainer">
			<div className="optionalBreakpointContainer">
				<p className="verifyUserText">Verifying magic link...</p>
			</div>
		</div>
	);
};

export default UserInit;
